import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-wrapper">
      <div className="contact-container">
        <div className="contact-header">
          <span className="contact-eyebrow">Get in touch</span>

          <h1 className="contact-title">
            Contact <span>Us</span>
          </h1>

          <p className="contact-subtext">
            We’re here to assist with enquiries regarding software development,
            mobile applications, cloud infrastructure, IoT systems, digital
            platforms, or general support.
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-card">
            <div className="contact-icon-wrap">
              <div className="contact-icon-dot"></div>
            </div>
            <h3>Email</h3>
            <p>
              <a href="mailto:info@prycetech.sg">
                info@prycetech.sg
              </a>
            </p>
          </div>

          <div className="contact-card">
            <div className="contact-icon-wrap">
              <div className="contact-icon-dot"></div>
            </div>
            <h3>Phone</h3>
            <p>
              <a href="tel:+6589898221">+65 8989 8221</a>
            </p>
          </div>

          <div className="contact-card contact-card-wide">
            <div className="contact-icon-wrap">
              <div className="contact-icon-dot"></div>
            </div>
            <h3>Address</h3>
            <p>
              190 Woodlands Industrial Park E5
              <br />
              WOODLANDS BIZHUB #06-12
              <br />
              Singapore 757516
            </p>
            <em className="note">
              We may be out for onsite work at times. Call us anytime and we’ll
              get back to you as soon as possible.
            </em>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;